import { createAction } from '@reduxjs/toolkit'
import type { UpdateLabelFilterChangedPayload } from '../meter-table/meter-table-types'
import { type CustomerFilter } from './data-types'

/* Action Creators */

export const CustomerFilterChangedAction = createAction<CustomerFilter>('data/customer-filter-changed')
export const UpdateLabelFilterChangedAction = createAction<UpdateLabelFilterChangedPayload>('LABEL_FILTER_CHANGED')
